import { Rule } from 'entities/campaign';

export function hasBothEmailSourceRulesDefined(rules: Rule[]): boolean {
  const ruleTypes = rules.map(rule => rule.type);
  return ruleTypes.includes('.IncludeEmailSource') && ruleTypes.includes('.ExcludeEmailSource');
}
